import { Link } from 'react-router-dom';

const platforms = [
  { name: 'Windows', icon: 'ri-windows-line', desc: 'Windows 10/11', ver: 'v3.8.1', size: '80MB' },
  { name: 'macOS', icon: 'ri-apple-line', desc: 'macOS 12+', ver: 'v3.8.1', size: '95MB' },
  { name: 'Android', icon: 'ri-android-line', desc: 'Android 8.0+', ver: 'v3.8.0', size: '45MB' },
  { name: 'iOS', icon: 'ri-smartphone-line', desc: 'iOS 15+', ver: 'v3.8.0', size: '58MB' },
];

export default function DownloadSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4">
            下载中心
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            全平台支持，<strong className="text-primary-500">免费下载</strong>
          </h2>
          <p className="text-foreground-600 text-sm max-w-2xl mx-auto">
            91浏览器覆盖Windows、macOS、Android、iOS四大平台，选择您的设备开始极速体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
          {platforms.map((p) => (
            <div key={p.name} className="bg-background-50 rounded-xl border border-background-200/70 p-6 text-center hover:border-primary-300/60 transition-all duration-300">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className={`${p.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-1">{p.name}版</h3>
              <p className="text-xs text-foreground-500 mb-3">{p.desc}</p>
              <div className="text-xs text-foreground-500 mb-4">
                <span>{p.ver}</span>
                <span className="mx-2">·</span>
                <span>{p.size}</span>
              </div>
              <a
                href="#"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line text-sm"></i>
                立即下载
              </a>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/category/download"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
          >
            查看详细下载指引
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}